import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nav-search"
export default class extends Controller {
  open(event) {
    event.preventDefault()
    window.dispatchEvent(new CustomEvent('floating-search:open'))
  }
}
